import BaseService from '../../base/base_service';
import IPariPlayService, {IPariplayFusion} from './pariplay_service_interface';


interface PariPlayServiceParams {
    fusionInclusionUrl: string;
}

export default class PariPlayService extends BaseService implements IPariPlayService {
    static CLASS = 'PariPlayService';

    private _initParams: PariPlayServiceParams = null;

    init(params: PariPlayServiceParams) {
        super.init(params);
        this._initParams = params;
    }

    private _fusion: IPariplayFusion = null;


    private _getFusion(): Promise<any> {
        if(this._fusion) {
            this.logger.info(`Pariplay fusion object was already loaded`);
            return Promise.resolve(this._fusion);
        }
        return this.serviceFactory.scriptLoaderService().loadScript(this._initParams.fusionInclusionUrl, 'PariPlayFusion')
            .then(() => {
                const fusion = this.serviceFactory.windowService().getGlobalProperty('fusion');
                if(!fusion) {
                    throw new Error('Pariplay fusion object was not found in the window global scope');
                }
                this.logger.info(`Pariplay fusion inclusion script was successfully loaded`);
                this._fusion = fusion;
                return this._fusion;
            });
    }

    initFusion(pariplayGameCode: string): Promise<IPariplayFusion> {
        this.logger.info(`Initializing Pariplay fusion for game code ${pariplayGameCode}`);
        return this._getFusion().then(fusion => {

            return new Promise((resolve, reject) => {
                let timeout = setTimeout(() => {
                    const msg = 'Pariplay fusion.init() timeout';
                    this.logger.error(msg);
                    reject(msg);
                }, 10000); // this is just in case fusion.init() doesn't call either onSuccess or onError.

                fusion.init({
                    gameCode: pariplayGameCode,
                    onSuccess: () => {
                        clearTimeout(timeout);
                        this.logger.info(`Initialized Pariplay fusion for game code ${pariplayGameCode}`);
                        resolve(fusion);
                    },
                    onError: (err) => {
                        clearTimeout(timeout);
                        this.logger.error(`Failed to init Pariplay fusion for game code ${pariplayGameCode}; errorDetails: ${JSON.stringify(err)}`);
                        reject(err);
                    }
                });
            });
        }).then(fusion => {
            return  fusion as IPariplayFusion;
        });
    }
}
